/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_NameInputs */

const en_contact_form_name = /** @type {(inputs: Contact_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your name`)
};

const pl_contact_form_name = /** @type {(inputs: Contact_Form_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię i nazwisko`)
};

/**
* | output |
* | --- |
* | "Your name" |
*
* @param {Contact_Form_NameInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_name = /** @type {((inputs?: Contact_Form_NameInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_NameInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_name(inputs)
	return en_contact_form_name(inputs)
});